<a [routerLink]="[dataHref]"
   (click)="setEshop()"
   routerLinkActive="active-link"
   class="{{dataClasses}}">
    <span class="link-text" translate>{{dataText}}</span>
</a>
